<template>
  <div class="r-cover z-0 overflow-hidden flex-c">
    <div class="relative w-full max-h-full overflow-auto scrolling-touch">
      <div 
        class="relative w-full mx-auto my-8 px-4 flex justify-center items-center flex-col overflow-hidden text-center home-logo-content" 
      >
        <div class="max-w-full mx-auto mb-10">
          <Logo
            :color="logoColor"
            :mobile-max-width="230"
            :full-max-width="380"
            :mobile-max-height="60"
            :full-max-height="100"
          />
        </div>
        <div class="px-5">
          <Heading class="home-logo-heading" :heading-obj="homePage.heading" />
          <Subheading home :subheading-obj="homePage.subheading" />
        </div>
        <ButtonList class="justify-center" />
      </div>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" width="443.173" height="601.611" viewBox="0 0 443.173 601.611" v-bind:svg-inline="''" v-bind:class="'home-logo-bg'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path data-name="Path 1477" d="M2.497 2.5v487.2l219.09 109.118L440.672 489.7V2.5z" fill="rgba(0,0,0,0.62)" stroke="#fff" stroke-width="5"/></svg>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'
import Heading from '@/components/Home/Heading.vue'
import Subheading from '@/components/Home/Subheading.vue'
import ButtonList from '@/components/Home/ButtonList.vue'
import SvgIcon from '@/components/SvgIcon.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Home_Centered',

  components: {
    Logo,
    Heading,
    Subheading,
    ButtonList,
    SvgIcon
  },

  props: {
    homePage: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters([
      'myStore'
    ]),
    logoColor() { return this.homePage.logo_slug || 'white' },
    homeStyles() { return this.myStore(['styles', 'home_screen']) ?? {} },
    overlayStyles() { return this.homeStyles.background ?? {} },
  }
}
</script>

<style scoped>
  .home-logo-bg {
    position: absolute;
    z-index: -1;
    top: 52%;
    max-width: 80%;
    transform: translateY(-50%);
  }

  .home-logo-content {
    max-width: 30rem;
  }

  .home-logo-heading {
    font-size: 26px;
    font-weight: bold;
  }

  @screen md {
    .home-logo-heading {
      font-size: 38px;
    }
  }
</style>

